import { Injectable } from '@angular/core'
import { COOKIE_STORAGE_KEYS } from '@shared/constants'
import { CookieStorageKeysType } from '@shared/types'
import { CookieService } from 'ngx-cookie-service'

@Injectable({
  providedIn: 'root',
})
export class CookieStorageService {
  constructor(private cookieService: CookieService) {}

  setItem(key: CookieStorageKeysType, value: string): void {
    this.cookieService.set(COOKIE_STORAGE_KEYS[key], value, { secure: true, path: '/', sameSite: 'Strict' })
  }

  getItem(key: CookieStorageKeysType): string {
    return this.cookieService.get(COOKIE_STORAGE_KEYS[key])
  }

  removeItem(key: CookieStorageKeysType): void {
    this.cookieService.delete(COOKIE_STORAGE_KEYS[key], '/')
  }

  clearAllCookie(): void {
    this.cookieService.deleteAll()
  }
}
